/** 拼接 className:过滤 falsy 值后以空格连接。内部工具,不对外导出。 */
export function cx(...parts) {
    return parts.filter(Boolean).join(' ');
}
